/**
 * better to ask Felix if you're not sure if something is general term or not
 * do not mistake with "simple" translations like "submit" or "cancel"
 * never use for composition
 *
 * generalTerm translations are something, which are specific to project "domain" or "project"
 * "common" translations are everything, which can be reused across different projects
 *
 * TODO: extract "common" above this object in order to reuse some translations
 */
export const generalTerm = {
  CCTDiagram: 'CCT diagram',
  area: 'Oblasť | Oblasti',
  asset: 'Zariadenie',
  assetId: 'ID zariadenia',
  assetType: 'Typ zariadenia',
  austenite: 'Austenit',
  automat: 'Automat | Automaty',
  carbonPotential: 'Uhlíkový potenciál',
  chamber: 'Komora | Komory',
  chart: 'Graf | Grafy',
  color: 'Farba',
  company: 'Spoločnosť | Spoločnosti',
  component: 'Komponent | Komponenty',
  composition: 'Zloženie',
  createdAt: 'Vytvorené',
  createdBy: 'Vytvoril',
  deletedAt: 'Odstránené dňa',
  deletedBy: 'Odstránil',
  deleted: 'Odstránené',
  customer: 'Zákazník',
  data: 'Údaje',
  dataSourceId: 'Zdroj dát',
  dataSourceReference: 'Referencia zdroja dát',
  date: 'Dátum',
  description: 'Popis',
  displayName: 'Názov',
  drawingReference: 'Referencia výkresu',
  element: 'Prvok | Prvky',
  email: 'E-mail',
  envelope: 'Obálka',
  equipment: 'Vybavenie | Vybavenie',
  equipmentGroup: 'Skupina vybavenia | Skupiny vybavenia',
  event: 'Udalosť | Udalosti',
  fullName: 'Celé meno',
  gasComposition: 'Zloženie plynu',
  generalInformation: 'Všeobecné informácie',
  heatTreatmentCapability: 'Možnosť tepelného spracovania | Možnosti tepelného spracovania',
  heatTreatmentProcess: 'Proces tepelného spracovania | Procesy tepelného spracovania',
  height: 'Výška',
  job: 'Zákazka | Zákazky',
  jobDisplayName: 'Č. záťaže',
  jobFinishedAtUtc: 'Čas ukončenia',
  jobId: 'ID zákazky',
  jobStartedAtUtc: 'Čas začiatku',
  jominyDiagram: 'Jominyho krivka',
  lastModifiedAt: 'Dátum úpravy',
  lastModifiedBy: 'Upravil',
  limitMinus: 'Limit -',
  limitPlus: 'Limit +',
  loadIdentifier: 'Identifikátor záťaže',
  location: 'Lokalita | Lokality',
  locationId: 'ID lokality',
  machine: 'Stroj | Stroje',
  manufacturer: 'Výrobca',
  mappedPT9800user: 'Priradený používateľ Protherm',
  material: 'Materiál',
  materialCalculationModel: 'Model výpočtu materiálu',
  materialSystemList: 'Materiálové systémy',
  measure: 'Miera | Miery',
  name: 'Názov',
  nitrogenPotential: 'Dusíkový potenciál',
  orientation: 'Orientácia',
  overwrite: 'Prepísať',
  part: 'Diel',
  partId: 'ID dielu',
  partNumber: 'Číslo dielu',
  preference: 'Predvoľba | Predvoľby',
  preset: 'Prednastavenie',
  processFlow: 'Tok procesu | Toky procesov',
  processValuesChart: 'Graf procesných hodnôt',
  production: 'Výroba',
  profileChart: 'Graf profilu',
  profileTable: 'Tabuľka profilov',
  recipe: 'Recept | Recepty',
  recipeStage: 'Etapa receptu',
  recipeStep: 'Krok',
  report: 'Správa',
  reportId: 'Č. správy',
  reporter: 'Reportér',
  requirement: 'Požiadavka',
  result: 'Výsledok',
  revision: 'Revízia',
  root: 'Koreň | Korene',
  scadaType: 'Typ SCADA',
  schaefflerDiagram: 'Schäfflerov diagram',
  send: 'Odoslať',
  sensor: 'Senzor',
  setpoint: 'Nastavená hodnota | Nastavené hodnoty',
  showDeleted: 'Zobraziť vymazané',
  signal: 'Signál | Signály',
  sms: 'SMS',
  sparePart: 'Náhradný diel | Náhradné diely',
  step: 'Krok',
  surfaceCarbide: 'Povrchový karbid',
  surfaceCarbon: 'Povrchový uhlík',
  surfaceNitrogen: 'Povrchový dusík',
  temperingCurveDiagram: 'Krivka popúšťania',
  title: 'Nadpis',
  unit: 'Jednotka | Jednotky',
  upload: 'Nahrať',
  width: 'Šírka',
  zone: 'Zóna | Zóny',

  // Diffusion / simulation inputs — shared by the Diffusion Inputs panel
  // (form-pt9800-diffusion-inputs.vue) and the /simulator page. Wording mirrors the simulator.
  alloyFactor: 'Legovačý faktor C',
  carbonContent: 'Obsah uhlíka v jadre',
  carbideLimit: 'Limit karbidov',
  carbonMonoxide: 'Oxid uhoľnatý CO',
  hydrogen: 'Vodík H₂',
  quenchingIntensity: 'Intenzita kalenia',
  representativeDiameter: 'Reprezentatívny priemer vzorky (DIN 17211)',
  requiredHardness: 'Efektívna tvrdosť povrchovej vrstvy',
  grainSize: 'Číslo veľkosti zrna ASTM',
  endTemperature: 'Konečná teplota',
  carburizingDepth: 'HĻbka cementácie',
  nitridingDepth: 'Hĺbka efektívnej tvrdosti (NHD)',
  referenceCarbon: 'Uhlík v hĺbke cementácie',
  targetSurfaceCarbon: 'Cieľový povrchový uhlík',
};

// used in tables or other places where you need to filter by general term
export const generalTermFilter = {
  asset: 'Hľadať zariadenie',
};
